import { render } from "./BasketIcon.vue?vue&type=template&id=53607d86"
import script from "./BasketIcon.vue?vue&type=script&lang=js"
export * from "./BasketIcon.vue?vue&type=script&lang=js"

import "./BasketIcon.vue?vue&type=style&index=0&id=53607d86&lang=scss"

import exportComponent from "/codebuild/output/src1478180041/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__